import React from 'react';
import { connect } from 'react-redux';

// Component
import RemainderWorkList from '../../../../remainder/helper/component/RemainderWorkList/RemainderWorkList.js';

// Modal
import ModalRemainderAdd from '../../../../remainder/helper/component/Modal/ModalRemainderAdd.js';
import ModalRemainderEdit from '../../../../remainder/helper/component/Modal/ModalRemainderEdit.js';


export class RemainderByWorkScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalRegister: false,
      modalEdit    : false,
      newData      : null,
      updateData   : null,
      update: false,
      work: {
        alias: props.match.params.Alias,
        assetName: props.match.params.AssetName
      },
    }

    this.openModal      = this.openModal.bind(this);
    this.closeModal     = this.closeModal.bind(this);
    
    this.openModalEdit  = this.openModalEdit.bind(this);
    this.closeModalEdit = this.closeModalEdit.bind(this);
    
    this.newRow    = this.newRow.bind(this);
    this.updateRow = this.updateRow.bind(this);
  }

  newRow(response) {
    this.setState({newData: response})
  }

  updateRow(update) {
    this.setState({update: update})
  }

  openModal() {
    this.setState({modalRegister: true})
  }

  closeModal() {
    this.setState({modalRegister: false})
  }

  openModalEdit(data) {
    this.setState({
      updateData: data,
      modalEdit: true
    })
  }

  closeModalEdit() {
    this.setState({modalEdit: false})
  }

  render() {
    const props = this.props;
    const {assetName} = this.state.work; 

    return (
      <div className="animated fadeIn">
        <div className="row">
          <div className="col-md-12">
            <div className="card-block white-background">
              <div className="page-header">
                <h4 className="space-between">
                  <span>
                    <button onClick={()=>this.props.history.goBack()} className="button-back btn-link no-underline" role="presentation"><i className="fa fa-arrow-left" /></button>
                    <span>Reminder List</span>&nbsp;
                    <small>for asset</small>&nbsp;<span>{assetName}</span>
                  </span>
                  <button onClick={()=>this.openModal()} type="button" className="btn btn-sm btn-primary">
                    <i className="fa fa-dot-circle-o"></i>&nbsp;Register Remainder
                  </button>
                </h4>
              </div>
              <hr/>
              <RemainderWorkList {...props}
                work          ={this.state.work}
                newData       ={this.state.newData}
                update        ={this.state.update}
                updateRow   ={this.updateRow}
                openModalEdit ={this.openModalEdit}
              />
            </div>
          </div>
        </div>
        <ModalRemainderAdd
          work          ={this.state.work}
          modalRegister ={this.state.modalRegister} 
          openModal     ={this.openModal}
          closeModal    ={this.closeModal}
          newRow        ={this.newRow}
          UserReducer   ={this.props.UserReducer}
        />
        <ModalRemainderEdit 
          modalEdit   ={this.state.modalEdit}
          UserReducer ={this.props.UserReducer}
          openModal   ={this.openModalEdit}
          closeModal  ={this.closeModalEdit}
          updateRow   ={this.updateRow}
          updateData  ={this.state.updateData}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    UserReducer: state.UserReducer,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    RunRedux: data => {
      dispatch(data);
    }
  };
};

export default connect(mapStateToProps,mapDispatchToProps)(RemainderByWorkScreen)



// WEBPACK FOOTER //
// ./src/App/views/templates/dashboard/remainder/remainder_by_work.js